module.exports = __webpack_public_path__ + "img/Poorter_hotel-396.22710283.jpg";